import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import type { ChangeEvent, FocusEventHandler } from 'react';

interface LabeledCheckBoxProps {
  label: string;
  name?: string;
  indeterminate?: boolean;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: FocusEventHandler;
  disabled?: boolean;
}

const LabeledCheckBox = ({
  label,
  name,
  indeterminate,
  checked,
  onChange,
  onBlur,
  disabled
}: LabeledCheckBoxProps) => {
  return (
    <FormControl>
      <FormControlLabel
        sx={{ marginLeft: 0 }}
        label={label}
        disabled={disabled}
        control={
          <Checkbox
            name={name}
            checked={checked}
            indeterminate={indeterminate}
            onChange={onChange}
            onBlur={onBlur}
            onClick={(e) => e.stopPropagation()}
          />
        }
      />
    </FormControl>
  );
};

export default LabeledCheckBox;
